export default __webpack_public_path__ + "static/media/Blade's Fauld of Waning Dusk.e9d28e2d.jpg";